import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React, { useEffect } from "react";

function LabReportLink() {
  const loadingIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  const getCodeFromURL = () => {
    const query = window.location.search;
    const codeMatch = query.match(/ref=([^&]*)/);
    return codeMatch ? codeMatch[1] : null;
  };

  useEffect(() => {
    const param = getCodeFromURL();
    setTimeout(() => {
      if (param) {
        window.location.href = process.env.REACT_APP_IMAGE_URL + param;
      }
    }, 100);
  }, []);

  return (
    <div>
      <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <Spin indicator={loadingIcon} size="large" />
      </div>
    </div>
  );
}

export default LabReportLink;
